import * as types from '@/store/types';

export default {
  [types.GETTER_MAP_STATUS]: state => state.selectedStatus,
  [types.GETTER_MAP_SELECTED_DATE]: state => state.selectedDate,
};
